import type { FaireProductEntity } from "../../entity_types/product";

export const p_fft6u3mzqw: FaireProductEntity = {
  token: "p_fft6u3mzqw",
  type: "product",
  name: "52oz Simply Lemonade with Raspberry Juice Fruit Beverage",
  brandToken: "b_7b25cuen6n",
  brandName: "EcoQuality",
  imageUrl:
    "https://cdn.faire.com/fastly/7a0b144a0d65e7339bda3a4b6d982597c1540e33c0a1a3a7f420322c6c12cd87.png",
  galleryImageUrls: [],
  priceDollars: 41.6,
  description:
    "52oz Simply Lemonade with Raspberry Juice Pure Fruit Beverage\n\n52oz Simply Raspberry Lemonade Juice is a refreshing fruit beverage made with lemon and raspberry juice for a bright sweet and tangy flavor. This ready to drink lemonade blend delivers a smooth balance of citrus and berry taste that pairs well with meals, snacks, and everyday refreshment. The 52oz bottle provides a generous family size serving, making it ideal for home kitchens, gatherings, picnics, and daily hydration.\n\nFeatures:\nMade with real lemon and raspberry juices\nNo preservatives or artificial ingredients\nSweet and tangy flavor for any occasion\nRefreshing beverage for family or guests\nFresh taste in every 52oz bottle\nGreat for meals, picnics, and everyday hydration\nReady to drink beverage perfect for on the go refreshment\nFull case includes 6 bottles",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:07.578Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
